import React from 'react';

export interface TrustedByProps {
  firmNames?: string[];
  peBackedReviewQuote?: string;
}

export default function TrustedBy({
  firmNames = [],
  peBackedReviewQuote = '',
}: TrustedByProps) {
  return (
    <div className="relative p-[0px]">
      <p
        className="font-['Hanken_Grotesk',sans-serif] text-[20px] font-bold leading-[36px] tracking-[0.75px] text-[#132543]"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        Trusted By Top PE Firms Like
      </p>

      {firmNames.length > 0 && (
        <div className="mt-[14px] flex flex-wrap items-center gap-x-[10px] gap-y-[10px]">
          {firmNames.slice(0, 6).map((name, idx) => (
            <div
              key={`${name}-${idx}`}
              className="flex h-[44px] items-center rounded-[50px] bg-[#2A9AC6] px-[18px] font-['Hanken_Grotesk',sans-serif] text-[13px] font-bold leading-[20px] text-white"
              style={{ fontVariationSettings: "'wdth' 100", letterSpacing: '0.35px' }}
            >
              {name}
            </div>
          ))}
        </div>
      )}

      {!!peBackedReviewQuote && (
        <div className="mt-[32px]">
          <p
            className="font-['Hanken_Grotesk',sans-serif] text-[20px] font-bold leading-[36px] tracking-[0.75px] text-[#132543]"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            PE-Backed Review
          </p>

          <div
            className="mt-[16px] rounded-[20px] border-[0.5px] border-solid border-[#A3A3A3] bg-white px-[24px] py-[20px]"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="mb-0 font-['Open_Sans',sans-serif] text-[14px] font-normal leading-[22.75px] text-[#31394C]">
              {peBackedReviewQuote}
            </p>
          </div>
        </div>
      )}

    </div>
  );
}
